export default __webpack_public_path__ + "static/about-data-09b3f6d813b5d495675aa0c438c9ea0e.png";